import { Button as BaseButton, type ButtonProps } from '@payaca/ambrosia';
import { DistributiveOmit } from '@payaca/utilities/types';
import { FC, PropsWithChildren } from 'react';

export const Banner: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="bg-linear-to-r from-purple-600 to-blue-400 text-white">
      {/* oxlint-disable-next-line payaca/no-tailwind-arbitrary-values */}
      <div className="mx-auto max-w-[150rem] px-4 py-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </div>
  );
};

export const Button: FC<
  DistributiveOmit<ButtonProps, 'colour' | 'variant' | 'linkColour'>
> = (buttonProps) => {
  return (
    <BaseButton
      {...buttonProps}
      variant={'secondary'}
      size={buttonProps.size || 'sm'}
    />
  );
};

export const AnnouncementBanner = Object.assign(Banner, {
  Button,
});
